import { CreateCustomer } from '@/components/customer/create'
import { createFileRoute } from '@tanstack/react-router'
import { store } from '@/state/breadcrumb-store'

export const Route = createFileRoute('/customer/create')({
  component: RouteComponent,
})

function RouteComponent() {
  store.trigger.changePath({
    newPath:
      [{ params: {}, to: "/customer", label: "Customer" },
      { params: {}, to: "/customer/create", label: "Create" },
      ]
  })
  return <div>
    <CreateCustomer></CreateCustomer>

  </div>
}
